module.exports = __webpack_public_path__ + "media/images/flags/64/Madagascar-3c74702bff898c4e232d190755bd308e.png";